import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Cookies from "universal-cookie";
import { motion } from "framer-motion";

const Cookie = () => {
  const cookies = new Cookies();
  const [accepted, setAccepted] = useState(true);

  useEffect(() => {
    if (localStorage.getItem("cookie-policy")) {
      setAccepted(true);
    } else {
      setAccepted(false);
    }
  }, []);

  const handleClick = () => {
    localStorage.setItem("cookie-policy", "true");
    cookies.set("cookie-policy", true, {
      secure: true,
      sameSite: "none",
      expires: new Date(Date.now() + 31536000000),
    });
    setAccepted(true);
  };

  return (
    <>
      {!accepted && (
        <motion.div
          className="cookie-consent"
          initial={{ opacity: 0, z: 100 }}
          animate={{ opacity: 1, z: 0 }}
          exit={{ opacity: 0, z: -100 }}
          transition={{ duration: 0.5, delay: 0.5 }}
        >
          <div className="disclaimer">
            <p>
              This website uses
              <span>
                <Link to="/privacy-policy">cookies</Link>
              </span>
            </p>
            <button onClick={handleClick}>Accept</button>
          </div>
        </motion.div>
      )}
    </>
  );
};

export default Cookie;
